/** Presentation only. Authorization remains with the existing route and API guards. */
export function isManagementShellPilot(basename: string, pathname: string): boolean {
  return import.meta.env.VITE_MANAGEMENT_SHELL_PILOT !== 'false'
    && basename === '/manager'
    && ['/', '/tasks'].includes(pathname.replace(/\/$/, '') || '/');
}
